// ob-fix: Configuration flags for robust onboarding
export const FUNCTIONS_REGION = process.env.NEXT_PUBLIC_FUNCTIONS_REGION || "us-central1";

// Skip onboarding feature flag - DISABLED for production
export const SKIP_ONBOARDING = false; // Always false in production

// Other flags can be added here
export const ENABLE_DEBUG_LOGGING = process.env.NODE_ENV === 'development';

// Onboarding feature flags
export const ENABLE_ONBOARDING_GOALS = process.env.NEXT_PUBLIC_ENABLE_ONBOARDING_GOALS === "true" || true; // Force enabled for testing
export const ENABLE_ONBOARDING_BIZ = true; // Force enabled for testing

// ============================================================================
// FUNDING MODE: Hide incomplete/test features for demo
// Set to false to hide test pages and incomplete features
// ============================================================================
export const FUNDING_MODE = true; // Enable to hide incomplete features

// Test/Development pages - hidden in funding mode
export const SHOW_GEMINI_TEST = !FUNDING_MODE && process.env.NODE_ENV === 'development';
export const SHOW_SOCIAL_SHARING_DEMO = !FUNDING_MODE && process.env.NODE_ENV === 'development';

// Incomplete features - hidden in funding mode until ready
export const SHOW_MINDSET_TOOLS = !FUNDING_MODE; // Mindset tools in ContentHub
export const SHOW_FEEDS_PAGE = true; // Feeds page is working
export const SHOW_SOCIAL_MEDIA_HUB = true; // Social Media Hub is working

// Legacy flags for compatibility
export const FEATURE_SNIPPETS = true;
export const DEFAULT_TZ = process.env.NEXT_PUBLIC_DEFAULT_TZ || 'Europe/Amsterdam';
export const ENABLE_AUTOPOST_LINKEDIN = true;
export const ALLOW_YOUTUBE_DOWNLOAD = true;

// Availability feature flag
export const ENABLE_AVAILABILITY = process.env.NEXT_PUBLIC_ENABLE_AVAILABILITY === "true" || false;

// Feed tools flags
export const FEATURE_POST_CTA = true;
export const FEATURE_SCREEN_LOCK = true;
export const FEATURE_REPLY_INTRO_PILL = true;
export const FEATURE_EXPERT_INDEX_STATUS = true;

// Screen lock policy defaults
export const SCREEN_LOCK_DURATION_SECONDS = 5;
export const SCREEN_LOCK_X_DEFAULT_DESKTOP = 18;
export const SCREEN_LOCK_X_DEFAULT_MOBILE = 24;
export const SCREEN_LOCK_X_MIN = 12;
export const SCREEN_LOCK_X_MAX = 40;
export const SCREEN_LOCK_MIN_ITEMS_BEFORE_FIRST = 10;
export const SCREEN_LOCK_MAX_PER_SESSION_DESKTOP = 3;
export const SCREEN_LOCK_MAX_PER_SESSION_MOBILE = 2;
export const SCREEN_LOCK_MIN_MINUTES_BETWEEN_DESKTOP = 5;
export const SCREEN_LOCK_MIN_MINUTES_BETWEEN_MOBILE = 8;
export const SCREEN_LOCK_COOLDOWN_AFTER_SKIP_MINUTES = 10;
export const SCREEN_LOCK_RELEVANCE_THRESHOLD = 65;